import { from, of } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import axios from 'axios';
import { dfimAxios } from '../config/Axios';
import {
  OPSLAG,
  DAWA_LOOKUP,
  opslagSuccess,
  opslagError,
  dawaLookupSuccess,
  dawaLookupError,
} from '../actions/Search';

const searchRequest = (input) =>
  dfimAxios
    .post('/api/opslag/unpaidfee', input, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);

const dawaLookup = (input) =>
  axios
    .get('https://dawa.aws.dk/adresser/autocomplete', {
      params: {
        q: input,
        per_side: 50,
      },
    })
    .then((response) => response.data);

export const searchEpic = (action$) =>
  action$.pipe(
    ofType(OPSLAG),
    switchMap((action) =>
      from(searchRequest(action.payload)).pipe(
        map((data) => opslagSuccess(data)),
        catchError((error) => of(opslagError(error)))
      )
    )
  );

export const dawaLookupEpic = (action$) =>
  action$.pipe(
    ofType(DAWA_LOOKUP),
    switchMap((action) =>
      from(dawaLookup(action.payload)).pipe(
        map((data) => dawaLookupSuccess(data)),
        catchError((error) => of(dawaLookupError(error)))
      )
    )
  );

// eslint-disable-next-line import/no-anonymous-default-export
export default [searchEpic, dawaLookupEpic];
